<template>
  <div class="v_foot">
    <div class="footerTop">
      <div class="mainContent">
        <div class="footer_warpper">
          <!--          <div class="item left">-->
          <!--            <div class="imgWarpper">-->
          <!--              <img class="img" src="../../assets/images/logo4.png" alt srcset />-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="item left">
            <span class="title">关于我们/About Us</span>
            <div class="content">{{ agreemenInfo.info }}</div>
          </div>
          <div class="item left contact">
            <img v-if="false" :src="agreemenInfo.wechat_code" alt />
            <div class="cText">
              <span class="title">关注我们/Follow Us</span>
              <p class="content">扫一扫关注</p>
              <p class="content">{{ agreemenInfo.wechat_name }}</p>
            </div>
          </div>
          <div class="item" style="width: auto">
            <span class="title">联系我们/Contact Us</span>
            <p class="content">电话：{{ agreemenInfo.mobile }}</p>
            <p class="content">地址：{{ agreemenInfo.address }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="footerTab">
      <div class="content">
        <!--        <div class="item">关于我们 | 联系我们</div>-->
        <div class="item">
          <span class="span" v-text="icp_number"></span>
        </div>
      </div>
    </div>

    <el-dialog
      :show-close="false"
      :close-on-click-modal="false"
      :visible.sync="isReciveCall"
      width="50%"
      center
    >
      <div class="invite">
        <div class="avatar">
          <img :src="targetInfo.avatar | headerFilter" />
        </div>
        <div v-if="sickInfo.patientName" class="tip">{{ sickInfo.patientName }}的视频聊天邀请</div>
        <div v-else class="tip">您有一个视频聊天邀请</div>
        <div class="foot">
          <el-button type="danger" @click="rejectInvite()" round
            >拒绝</el-button
          >
          <el-button type="success" @click="acceptInvite()" round
            >接听</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from "@/utils";

import { agreemenInfo } from "@/api";
import { updateVideoStatus } from "@/api/doctor";
import cookie from "@/utils/cookie";
export default {
  name: "Footer",
  data() {
    return {
      agreemenInfo: {},
      icp_number: process.env.VUE_APP_ICP_NUMBER,
      websiteTitle: process.env.VUE_APP_WEBSITE_TITLE,

      audio: "",
      isReciveCall: false,
      targetInfo: "",
      uid: util.timest(),
      sickInfo: {},
    };
  },
  filters: {
    headerFilter: function(img) {
      if (img) {
        return img;
      } else {
        return require("../../assets/images/user-avatar.svg");
      }
    },
  },
  computed: {
    roomListenType() {
      return this.$store.state.roomListenData.eventType;
    },
    roomListenData() {
      return this.$store.state.roomListenData;
    },
  },
  watch: {
    roomListenData(val) {
      console.log(val);
      if (val && val.attachExt) {
        this.getOrderInfoById(val.attachExt);
      }
    },
    roomListenType(val) {
      console.log(val, "视频");
      if (!val) return;
      if (val === "INVITE") {
        this.isReciveCall = true;
        this.$store
          .dispatch("getUserInfo", this.roomListenData.from)
          .then((res) => {
            this.$nextTick(() => {
              this.targetInfo = res;
              this.isReciveCall = true;
              this.lingPlay();
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (val === "CANCEL_INVITE") {
        this.lingStop();
        this.isReciveCall = false;
      } else if (
        val === "REJECT" ||
        val === "ROOM_JOIN" ||
        val === "ROOM_CLOSE"
      ) {
        this.isReciveCall = false;
        this.lingStop();
      } else if (val === "ACCEPT") {
        this.lingStop();
        this.isReciveCall = false;
      }
    },
  },

  mounted() {
    // this.initData();
  },
  methods: {
    async initData() {
      try {
        const params = {};
        let res = await agreemenInfo(params);
        if (res.success) this.agreemenInfo = res.result;
      } catch (error) {}
    },

    lingStop() {
      const audio = this.audio;
      audio && audio.pause();
      this.audio = "";
      clearInterval(this.callTimer);
    },
    lingPlay() {
      this.audio = new Audio();
      this.audio.src = require("../../assets/begg.mp3");
      this.callTimer = setInterval(() => {
        this.audio &&
          this.audio
            .play()
            .then(() => {
              console.log("播放成功");
            })
            .catch(() => {
              // this.$message.error("音频设备未允许，请在设置中心允许播放音频");
              clearInterval(this.callTimer);
            });
      }, 1000);
    },
    // 拒绝
    rejectInvite() {
      const params = {
        channelId: this.roomListenData.channelId,
        account: this.roomListenData.from,
        requestId: this.roomListenData.requestId,
      };
      this.$store
        .dispatch("rejectInvite", params)
        .then(async (res) => {
          console.log("拒绝成功");
          this.lingStop();
          this.isReciveCall = false;
          this.$store.dispatch("setListenRoomData", "");
           await updateVideoStatus()
        })
        .catch((error) => {
          this.lingStop();
          this.isReciveCall = false;
          this.$store.dispatch("setListenRoomData", "");
          console.log("error", error);
          if (error.code == 10404) {
            this.$message.error("频道不存在");
          } else if (error.code == 10408) {
            this.$message.error("邀请不存在或已过期");
          } else if (error.code == 10409) {
            this.$message.error("邀请已经拒绝");
          } else if (error.code == 10410) {
            this.$message.error("邀请已经接受");
          } else if (error.code == 10201) {
            this.$message.error("对方不在线");
          }
        });
    },
    // 接听
    acceptInvite() {
      const params = {
        channelId: this.roomListenData.channelId,
        account: this.roomListenData.from,
        requestId: this.roomListenData.requestId,
      };
      this.$store
        .dispatch("acceptInvite", params)
        .then(async () => {
          this.lingStop();
          this.isReciveCall = false;
            this.$router.push({
              path: "/netcall",
              query: {
                channelName: this.roomListenData.channelName,
                requestId: this.uid,
                uid: this.uid,
                account: this.roomListenData.from,
                target: this.sickInfo.patientName,
                device: "1,2",
              },
            });
          // }
        })
        .catch((error) => {
          if (error.code == 10404) {
            this.$message.error("频道不存在");
          } else if (error.code == 10408) {
            this.$message.error("邀请不存在或已过期");
          } else if (error.code == 10409) {
            this.$message.error("邀请已经拒绝");
          } else if (error.code == 10410) {
            this.$message.error("邀请已经接受");
          } else if (error.code == 10201) {
            this.$message.error("对方不在线");
          }
        });
    },
    async getOrderInfoById(treatId) {
      try {
        let data = {
          orderNo: treatId,
        };
        const res = await getOrderDetail(data);
        if (res.code == 1) {
          this.sickInfo = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invite {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .avatar {
    width: 100px;
    height: 100px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin: 20px 0;
  }
  .foot {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .el-button {
      width: 120px;
    }
  }
}
.v_foot {
  width: 100%;
}

.span {
  background: url(../../assets/images/icon1.png) 0 center no-repeat;
  padding-left: 20px;
}
.footerTop {
  width: 100%;
  background: #222222;
  padding: 10px 0;
  // text-align: center;
  .follow {
    text-align: center;
    color: #fff;
    font-size: 16px;
  }
  .text {
    color: #999;
    margin: 30px 0 15px;
  }
  .qrImg {
    width: 100px;
    margin-top: 10px;
  }
  .text1 {
    color: #5b5b5b;
    span {
      background: url("../../assets/images/icon1.png") 0 center no-repeat;
      padding-left: 15px;
    }
  }

  .mainContent {
    // width: 1200px;
    margin: 0 auto;
    height: 120px;
    background: #222222;
    padding: 40px 0 25px 0;
    .footer_warpper {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .item {
        width: 251px;
        height: 90px;
        line-height: 22px;
        padding: 0 20px;
        .imgWarpper {
          text-align: center;
          .img {
            width: 100%;
          }
        }
        .title {
          font-size: 16px;
          color: #fff;
          display: inline-block;
          margin-bottom: 10px;
        }
        .content {
          font-size: 14px;
          color: #999999;
          .el-select {
            padding-top: 15px;
            ul {
              a {
                text-decoration: none;
              }
            }
          }
        }
      }
      .contact {
        display: flex;
        line-height: 22px;
        img {
          width: 36%;
        }
        .cText {
          padding-left: 10px;
          width: 230px;
        }
      }
    }
  }
}

.footerTab {
  width: 100%;
  background: #192227;
  height: 54px;
  .content {
    font-size: 14px;
    color: #999999;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    .item {
      margin: auto;
    }
  }
}
</style>
